import faker from '@faker-js/faker';
import {TNotificationList} from './types';

export const getNotificationList = (): TNotificationList => {
  return {
    transaction_for_customer: faker.datatype.boolean(),
    invoice_created: faker.datatype.boolean(),
    invoice_paid: faker.datatype.boolean(),
    invoice_cancelled: faker.datatype.boolean(),
    invoice_expired: faker.datatype.boolean(),
    refund_created: faker.datatype.boolean(),
    refund_completed: faker.datatype.boolean(),
    payouts_and_settlements: faker.datatype.boolean(),
    currency_added: faker.datatype.boolean(),
    bank_added: faker.datatype.boolean(),
    terminal_ordered: faker.datatype.boolean(),
  } as TNotificationList;
};
